import React, { createContext, useContext, useCallback } from 'react';

interface NotificationToastPayload {
  type: 'message' | 'app';
  mainText: string;
  subText: string;
}

interface NotificationToastContextValue {
  showNotification: (payload: NotificationToastPayload) => void;
}

const NotificationToastContext = createContext<NotificationToastContextValue>({
  showNotification: () => {},
});

export const useNotificationToast = () => useContext(NotificationToastContext);

export const NotificationToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const showNotification = useCallback((payload: NotificationToastPayload) => {
    console.log('[NotificationToast]', payload.mainText, payload.subText);
  }, []);

  return (
    <NotificationToastContext.Provider value={{ showNotification }}>
      {children}
    </NotificationToastContext.Provider>
  );
};
